import * as screens from '@core/layouts/components/menu/screens';
import permissions from './permissions';

export default [
  {
    id: 'videoDashboard',
    title: 'video.dashboard',
    iconName: 'Video',
    permissions: [permissions.videoDashboard],
    navLink: '/video',
    screenId: screens.VIDEO_DASHBOARD
  },
  {
    id: 'videoHistorico',
    title: 'video.historico.title',
    iconName: 'Video',
    permissions: [permissions.eventsHistory], // Sin permisos por ahora para pruebas
    navLink: '/video/historico',
    screenId: screens.VIDEO_HISTORICO
  }
];
